import { useCallback } from 'react';
import { useDiagramStore } from '../stores/diagramStore';
import { saveToJSON } from '../utils/serializer';
import { buildPublishedHash } from '../utils/publishCodec';
import { addPublishedLink, buildPublishedViewerUrl } from '../services/publish';

export function usePublishLink(activeProjectName: string, showToast: (message: string) => void) {
  const {
    diagramType, participants, messages, fragments, participantGroups,
    nodes, edges, viewport, layers, groups, pages, activePage, catalog,
  } = useDiagramStore();

  return useCallback(async () => {
    try {
      const json = saveToJSON({
        diagramType,
        participants,
        messages,
        fragments,
        participantGroups,
        nodes,
        edges,
        viewport,
        layers,
        groups,
        pages,
        activePage,
        catalog,
      });
      const published = buildPublishedHash(json);
      const url = buildPublishedViewerUrl(window.location.origin, published.hash);
      addPublishedLink({
        name: activeProjectName,
        url,
        hash: published.hash,
        checksum: published.checksum,
        payload: published.payload,
      });
      try {
        await navigator.clipboard.writeText(url);
        showToast('Publish link copied to clipboard');
      } catch {
        showToast('Publish link created');
      }
    } catch {
      showToast('Failed to publish this diagram');
    }
  }, [
    diagramType,
    participants,
    messages,
    fragments,
    participantGroups,
    nodes,
    edges,
    viewport,
    layers,
    groups,
    pages,
    activePage,
    catalog,
    activeProjectName,
    showToast,
  ]);
}
